var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs tabs-tertiary"},[_c('b-nav',{attrs:{"tabs":""}},[_c('b-nav-item',{attrs:{"to":"/enterprises"}},[_vm._v(" Find Enterprises ")]),_c('b-nav-item',{attrs:{"to":"/enterprises/connected","exact":""}},[_vm._v(" My Enterprises ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }